<template>
  <div class="my-select">
    <search-customer-seller :show-goback="false" />
  </div>
</template>

<script>
  import SearchCustomerSeller from '@/components/SearchCustomerSeller.vue';
  export default {
    name: 'SearchBar',
    components: {
      SearchCustomerSeller,
    },
  };
</script>
